import type { AgeDistributionItem } from '../types/totalAnalytics.types';

type AgeDistributionSectionProps = {
  items: AgeDistributionItem[];
  total: number;
};

export function AgeDistributionSection({
  items,
  total,
}: AgeDistributionSectionProps) {
  return (
    <section className="rounded-2xl border border-[var(--dash-line)] bg-white p-6 shadow-sm">
      <div className="mb-5 text-left">
        <h3 className="m-0 text-[15px] font-bold text-[var(--dash-ink)]">
          Age Distribution
        </h3>
        <p className="mt-0.5 mb-0 text-[13px] text-[var(--dash-muted)]">
          Viewer age groups
        </p>
      </div>

      <div className="flex flex-col gap-3.5">
        {items.map((item) => {
          const pct = total > 0 ? (item.count / total) * 100 : 0;
          return (
            <div key={item.label} className="flex items-center gap-3">
              <span className="w-14 shrink-0 text-[15px] font-semibold text-[var(--dash-ink)]">
                {item.label}
              </span>
              <div className="relative h-3.5 flex-1 overflow-hidden rounded-full bg-slate-100">
                <div
                  className="absolute inset-y-0 left-0 rounded-full bg-[#3B82F6] transition-all duration-700"
                  style={{
                    width: `${pct}%`,
                    minWidth: item.count > 0 ? '8px' : '0px',
                  }}
                />
              </div>
              <span className="min-w-[52px] shrink-0 text-right text-[15px] font-semibold text-[var(--dash-muted)]">
                {item.count.toLocaleString()}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
